<template>
    <div id="content">
        <link rel="stylesheet" href="/themes/ito/css/daily-challenge.css?v=5">

        <div class="container">
            <div id="page-header-fixed">
                <div class="container">
                    <div id="page-header">
                        <ul class="breadcrumb">
                            <li class="icon">
                                <a @click="$router.go(-1)">
                                    <img src="/themes/ito/images/back-to.svg" alt="">
                                </a>
                            </li>
                            <li>
                                <div class="buttons">
                                    <div class="btn-group">
                                        <router-link :to="{path: '/daily-challenge'}" @click.native="getSoundClick">
                                            <button type="button" class="btn btn-default" style="position: relative">{{ $t('daily_challenge') }}
                                                <div class="noti-alert" v-if="user_info.dailychallenge_noti != 0"></div>
                                            </button>
                                        </router-link>
                                        <button type="button" class="btn btn-default active" style="position: relative">{{ $t('daily_bonus') }}
                                            <div class="noti-alert" v-if="user_info.first_login == 1"></div>
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div id="daily-bonus" class="card card-daily-challenge">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="title">{{ $t('daily_bonus') }}</span>
                    </h5>

                    <div class="card-content">
                        <div id="daily-challenge" class="daily-bonus">
                            <div class="description">
                                <div class="col-1">
                                    {{ $t('daily_bonus_1') }}
                                </div>
                                <div class="col-2">
                                    {{ $t('daily_bonus_2') }}: <b>{{ time_next_bonus_txt }}</b>
                                </div>
                            </div>
                            <div class="challenges">
                                <div class="bonus-list">

                                    <template v-for="(bonus, index) in bonuses">
                                        <daily-bonus-item :bonus="bonus" :today_id="today_id" @updateBonus="updateBonus"/>
                                    </template>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {updateProfile} from '../../models/profile'
    import {showDialog} from '../../utils/dialog'
    import {mapGetters} from 'vuex'
    import axios from "axios";
    import {getDailyBonus, getDailyChallenge} from "../../models/reward";
    import DailyBonusItem from "./DailyBonusItem";
    import {convertSecondToText, soundClick} from "../../utils/utils";

    export default {
        name: "DailyBonus",
        components: { DailyBonusItem},
        title: 'Daily bonus',

        data() {
            return {
                bonuses: '',
                today_id: '',
                time_next_bonus: '',
                time_next_bonus_txt: '',
            };
        },

        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }

                return this.user
            })
        },

        created() {
            this.fetch();
        },

        watch: {
            time_next_bonus: {
                handler(value) {

                    if (value > 0) {
                        setTimeout(() => {
                            this.time_next_bonus--;

                            this.time_next_bonus_txt = convertSecondToText(this.time_next_bonus) || '';
                        }, 1000);
                    }

                },
                immediate: true // This ensures the watcher is triggered upon creation
            }

        },

        methods: {
            fetch() {
                const that = this;

                axios.all([
                    getDailyBonus(),
                ]).then(axios.spread((response) => {
                    that.isLoading = false;

                    if (response.data.code != 0) {
                        return;
                    }

                    that.bonuses = response.data.results.daily_bonus || [];
                    that.today_id = response.data.results.today_id || '';
                    that.time_next_bonus = response.data.results.time_next_bonus || 0;
                    that.time_next_bonus_txt = convertSecondToText(that.time_next_bonus) || '';

                    /*that.bonuses.forEach(element => {
                        if(element.id == 36){
                            element.status = 1;
                        }
                    });*/
                }));
            },

            updateFirstLogin(key) {
                //console.log('xxx' + key + "zzz");
            },

            getSoundClick() {
                soundClick();
            },

            updateBonus(data) {
                this.user_info.first_login = 0;

                this.fetch();
            },
        }
    }
</script>

<style scoped>

</style>
